/**
 * Helpers centrais para filtros de Select (Radix).
 *
 * O componente Select reserva a string vazia para limpar a seleção e
 * mostrar o placeholder — por isso <SelectItem value=""> lança:
 *   "A <Select.Item /> must have a value prop that is not an empty string"
 * Toda opção "Todos/Nenhum" deve usar uma sentinela explícita não vazia,
 * normalizada antes de enviar parâmetros à API.
 */

/** Sentinela para "Todos / sem filtro". Nunca vai ao backend. */
export const FILTER_ALL = "__ALL__";

/** Sentinela para "Nenhum". Nunca vai ao backend. */
export const FILTER_NONE = "__NONE__";

/**
 * Converte o valor de um Select no parâmetro de filtro da API.
 * `undefined` = não enviar o parâmetro; `null` = filtro explícito "nenhum".
 */
export function normalizeSelectFilter(value) {
  if (value === null || value === undefined) return undefined;
  const normalized = String(value).trim();
  if (normalized === "" || normalized === FILTER_ALL) return undefined;
  if (normalized === FILTER_NONE) return null;
  return normalized;
}

/**
 * Converte o estado do filtro ("" = sem seleção) no valor exibido pelo
 * Select, garantindo que o <SelectItem> correspondente nunca seja "".
 */
export function toSelectValue(value, fallback = FILTER_ALL) {
  if (value === null || value === undefined) return fallback;
  const normalized = String(value).trim();
  return normalized === "" ? fallback : normalized;
}

/**
 * Remove itens de opções dinâmicas (clientes, unidades, áreas, etc.)
 * sem id/value utilizável, protegendo o render dos <SelectItem>.
 */
export function sanitizeSelectOptions(items) {
  if (!Array.isArray(items)) return [];
  return items.filter((item) => {
    if (item === null || typeof item !== "object") return false;
    const id = item.id ?? item.value ?? item.key;
    return String(id ?? "").trim() !== "";
  });
}
